import React, { useState } from "react";
import { Button, Modal } from "antd";
import { ShareAltOutlined } from "@ant-design/icons";

import { useDispatch, useSelector } from "react-redux";
import { emptyGeneratedHtml, generateHtml } from "../../actionCreator/webToLeadActionCreater";
import CopyText from "./CopyText";
import { configType } from "../../constant/WebToLead";
import copy from "../../assets/images/webToLead/copy.png";

const Share = ({ formData, isCopy }) => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const generatedHtml = useSelector(
    (state) => state.WebToLeadReducer.generatedHtml
  );
  const loading = useSelector((state) => state.WebToLeadReducer.loading);

  const showModal = () => {
    dispatch(
      generateHtml(
        formData?.id,
        formData.configType === configType.EMBEDDED_SCRIPT
      )
    );
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    dispatch(emptyGeneratedHtml());
  };

  return (
    <>
      {isCopy ? (
        <img
          src={copy}
          alt=""
          style={{
            width: 20,
            height: 20,
          }}
          className="cursor-pointer"
          onClick={showModal}
        />
      ) : (
        <div
          className="heading14px d-flex align-items-center"
          style={{ gap: 10, color: "#29292B", paddingRight: 30 }}
          onClick={showModal}
        >
          <ShareAltOutlined />
          Share
        </div>
      )}
      <Modal
        title={
          <div
            className="heading24px text-color-1C1C1C roboto-medium"
            style={{ padding: "20px 24px 10px" }}
          >
            {formData?.formName} Code
          </div>
        }
        width={623}
        loading={loading}
        className="delete-popup"
        open={isModalOpen}
        centered
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
      >
        <div
          style={{ padding: "0 24px 20px 24px" }}
          className="web-to-lead mt10"
        >
          <div className="w-100 title">
            <pre
              style={{
                maxHeight: "500px",
                overflow: "scroll",
              }}
            >
              <code style={{ color: "#959595" }}>{generatedHtml}</code>
            </pre>
          </div>
          <div
            className="mt40 d-flex justify-content-end align-items-center"
            style={{ gap: 20 }}
          >
            <Button className="secondary-btn" onClick={handleCancel}>
              Cancel
            </Button>
            <CopyText
              text={generatedHtml}
              content={
                <Button type="primary" className="theme-btn">
                  Copy Code
                </Button>
              }
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Share;
